import {
  Compass,
  UtensilsCrossed,
  BedDouble,
  Plane,
  Martini,
  Lightbulb,
} from "lucide-react";
import type { ItemType, TimeBucket } from "@/context/JourneyContext";

// Shared display constants for itinerary items. Used by Trip.tsx (the
// editable planner), TripMap (the map InfoWindow), and SharedTrip (the
// read-only share page) so all surfaces render the same icons and labels.

export const TYPE_ICON: Record<ItemType, React.ComponentType<{ className?: string }>> = {
  activity: Compass,
  dining: UtensilsCrossed,
  accommodation: BedDouble,
  transport: Plane,
  nightlife: Martini,
  tip: Lightbulb,
};

export const BUCKET_LABELS: Record<TimeBucket, string> = {
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  night: "Night",
};

export const BUCKETS: TimeBucket[] = ["morning", "afternoon", "evening", "night"];

export const BUCKET_ORDER: Record<TimeBucket, number> = {
  morning: 0,
  afternoon: 1,
  evening: 2,
  night: 3,
};

